/**
 * Optional extra horizontal scroller for MainLayout’s bottom fade rail.
 * Import metadata strips register here so the layout does not import features.
 */

let target: HTMLElement | null = null;
const listeners = new Set<() => void>();

/**
 * Sets the pane the bottom fade rail should drive. Pass `null` to detach.
 */
export const setMainHorizontalScrollTarget = (
  element: HTMLElement | null,
): void => {
  if (target === element) return;
  target = element;
  listeners.forEach((fn) => fn());
};

/**
 * The registered horizontal scroller, or `null` when none is attached.
 */
export const getMainHorizontalScrollTarget = (): HTMLElement | null => target;

/**
 * Subscribe to target attach/detach. Returns an unsubscribe function.
 */
export const subscribeMainHorizontalScrollTarget = (
  onChange: () => void,
): (() => void) => {
  listeners.add(onChange);
  return () => {
    listeners.delete(onChange);
  };
};
